<template>
  <footer>
    <div class="footer-menu text-md">
      <div class="footer-menu-block">
        <div class="sub-title text-sm">Search</div>
        <router-link :to="searchRecordsRoute">All Records</router-link>
        <router-link :to="{name: 'search-sources'}">All Sources</router-link>
        <router-link :to="{name: 'search-tool-surname'}">Surnames</router-link>
        <router-link :to="{name: 'search-tool-village'}">Chinese Villages</router-link>
        <router-link :to="{name: 'search-overseas'}">Overseas Communities</router-link>
      </div>
      <div class="footer-menu-block">
        <div class="sub-title text-sm">Resources</div>
        <router-link :to="{name: 'how-to-login'}">How to Login</router-link>
        <router-link :to="{name: 'wiki-index'}">Genealogy Wiki</router-link>
        <router-link :to="{name: 'image-to-text'}">Image to Text</router-link>
        <router-link :to="{name: 'events'}">Workshops & Events</router-link>
        <router-link :to="{name: 'support'}">Support</router-link>
      </div>
      <div class="footer-menu-block">
        <div class="sub-title text-sm">Policies</div>
        <router-link :to="{name: 'terms'}">Terms</router-link>
        <router-link :to="{name: 'privacy-policy'}">Privacy</router-link>
        <router-link :to="{name: 'accessibility'}">Accessibility</router-link>
      </div>
    </div>
    <div class="footer-info">
      <div>
        We help people of Chinese heritage find records of their ancestors, connect with long-lost relatives, and
        organize roots trips to China.
      </div>
    </div>
  </footer>
</template>

<script>
import {TAB_ID_AI_SEARCH} from '@common/utils/consts.search';

export default {
  computed: {
    searchRecordsRoute() {
      return {name: 'search-all-records', query: {tab: TAB_ID_AI_SEARCH}};
    },
  },
};
</script>

<style scoped lang="scss">
@use '@common/style/variables';
@use '@common/style/mixins';

footer {
  background-color: variables.$dark-background-color;
  color: variables.$dark-text-color;
  position: relative;
  padding: 36px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @include mixins.overlayGradient(180deg, rgba(black, 0.5), rgba(0, 0, 0, 0) 15px);

  a:not(.mcr-button) {
    color: variables.$dark-text-color;
  }

  .footer-menu {
    display: flex;
    width: 100%;
    column-gap: 100px;
    row-gap: 1.5rem;
    flex-wrap: wrap;
  }

  .footer-menu-block {
    display: flex;
    flex-direction: column;
    min-width: 100px;
    &:last-child {
      margin-right: 0;
    }
    .sub-title {
      font-weight: 600;
      text-transform: uppercase;
      margin-bottom: 0.35rem;
    }
    @media only screen and (max-width: variables.$breakpoint-mobile) {
      a {
        display: block;
        padding: 10px 0;
      }
    }
  }
  .footer-menu,
  .footer-info {
    max-width: 970px;
  }

  .footer-info {
    margin-top: 32px;
    margin-right: 0;
    border-top: 1px solid variables.$dark-divider-line;
    padding-top: 24px;
  }
}
</style>
